import { render, staticRenderFns } from "./VCommentForm.vue?vue&type=template&id=0c0fcf50"
import script from "./VCommentForm.vue?vue&type=script&lang=js"
export * from "./VCommentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports